import { i as e, r as t } from "./newsletter.service-b1LnfKOo.js";
import { t as n } from "./newsletter-list.selector-rioHEpT0.js";
import { defineAsyncComponent as r } from "vue";
import { getI18n as i } from "@editor/ui-utils";
//#endregion
//#region src/lang/index.ts
var a = {
	en: {
		newsletterApi: {
			createAlreadyExists: "The newsletter cannot be created because another newsletter with this name already exists.",
			updateAlreadyExists: "The newsletter cannot be updated because another newsletter with this name already exists.",
			created: "Newsletter created",
			updated: "Newsletter updated",
			notFound: "Newsletter not found",
			requiredFields: "The newsletter cannot be saved because mandatory information is missing."
		},
		newsletterList: {
			newButton: "New newsletter widget",
			name: "Search for label",
			deleteNewsletter: "Delete",
			dpAny: "All",
			brand: "Brand",
			loading: "Loading newsletter",
			headerLabel: "Label",
			headerCreatedAt: "Creation date",
			headerChangedAt: "Last modified date",
			counter: "Counter",
			dpEdit: "Edit",
			dpView: "View",
			messageDeleted: "Message deleted",
			errorOnDeleting: "Error deleting",
			createNewsletter: "Create Newsletter",
			newsletterWidgetName: "Newsletter widget title",
			newsletterRecipientGroup: "Recipient group",
			searchLabel: "Search for newsletter widget title, group or ID"
		},
		newsletter: {
			newsletterLabel: "Newsletter",
			newNewsletter: "Basics",
			messageDeleteNewsletter: "Delete newsletter",
			messageDeleteNewsletterTitle: "Are you sure you want to delete this newsletter?",
			deleteNewsletter: "Delete",
			messageDeleted: "Newsletter deleted",
			errorOnDeleting: "Error deleting the newsletter",
			errorFailedLoadedNewsletterWithId: "Error getting the newsletter",
			handledInLegacySystem: "This newsletter is being handled in {source} and cannot be edited in Vibe.",
			errorNewsletterFailedLoad: "Error loading {id}",
			newsletterWidgetName: "Newsletter widget title (internal)",
			newsletterReferrer: "Newsletter referrer",
			tooltipNewsletterReferrer: "Optional parameter which is passed on to the newsletter tool to track which widget generated a subscription, for example \"Sommerkampagne-2024\".",
			automationCampaign: "Automated campaign",
			tooltipAutomationCampaign: "If a campaign automation ID is specified (e.g. to provide a free PDF), the subscribing user will automatically be added to this campaign after confirming the double opt-in. The campaign must be created in ELAINE (Newsletter tool) in advance.",
			tooltipNewsletterWidgetName: "The newsletter widget title is only for internal usage.",
			template: "Design",
			headline: "Headline",
			text: "Text",
			newsletterWidget: "Newsletter widget",
			selectNewsletterWidget: "Select newsletter widget",
			tagLine: "Kicker",
			imageSelectorDescription: "Select or upload image",
			recipientGroupsCached: "Recipient groups served from cache — Elaine is unreachable",
			recipientGroupsLoadError: "Recipient groups could not be loaded",
			recipientGroupsBrandNotConfigured: "Recipient groups are not configured for this brand.",
			recipientGroupsElaineError: "Recipient groups could not be loaded",
			recipientGroupsElaineDown: "Recipient groups could not be loaded — Elaine is unreachable",
			noRecipientGroups: "No recipient groups found"
		},
		newsletterEdit: {
			label: "Label",
			counter: "Counter",
			editNewsletter: "Edit newsletter",
			messageSaved: "New Newsletter saved"
		}
	},
	de: {
		newsletterApi: {
			createAlreadyExists: "Der Newsletter kann nicht erstellt werden, da bereits ein Newsletter mit diesem Namen existiert.",
			updateAlreadyExists: "Der Newsletter kann nicht aktualisiert werden, da bereits ein Newsletter mit diesem Namen existiert.",
			created: "Newsletter erstellt",
			updated: "Newsletter aktualisiert",
			notFound: "Newsletter nicht gefunden",
			requiredFields: "Der Newsletter kann nicht gespeichert werden, weil Pflichtinformationen fehlen."
		},
		newsletterList: {
			newButton: "Neues Newsletter-Widget",
			name: "Suche nach Bezeichnung",
			deleteNewsletter: "Löschen",
			dpAny: "Alle",
			brand: "Marke",
			loading: "Newlsetter wird geladen",
			headerLabel: "Bezeichnung",
			headerCreatedAt: "Erstellungsdatum",
			headerChangedAt: "Änderungsdatum (last modified)",
			counter: "Zähler",
			dpEdit: "Bearbeiten",
			dpView: "Anzeigen",
			messageDeleted: "Nachricht gelöscht",
			errorOnDeleting: "Fehler beim Löschen",
			createNewsletter: "Newsletter erstellen",
			newsletterWidgetName: "Newsletter-Widget-Titel",
			newsletterRecipientGroup: "Empfängergruppe",
			searchLabel: "Suchen nach Newsletter-Widget-Titel, Gruppe oder ID"
		},
		newsletter: {
			newsletterLabel: "Newsletter",
			newNewsletter: "Basics",
			messageDeleteNewsletter: "Newsletter löschen",
			messageDeleteNewsletterTitle: "Willst du diesen Newsletter wirklich löschen?",
			deleteNewsletter: "Löschen",
			messageDeleted: "Newsletter gelöscht",
			errorOnDeleting: "Fehler beim Löschen des Newsletters",
			errorFailedLoadedNewsletterWithId: "Fehler beim Abrufen des Newsletters",
			handledInLegacySystem: "Dieser Newsletter wird in {source} verwaltet und kann nicht in Vibe bearbeitet werden.",
			errorNewsletterFailedLoad: "Fehler beim Laden von {id}",
			newsletterReferrer: "Newsletter-Referrer",
			newsletterWidgetName: "Newsletter-Widget-Titel (intern)",
			tooltipNewsletterReferrer: "Optionaler Parameter, der an das Newsletter-Tool weitergegeben wird, um zu tracken, welches Widget eine Subscription generiert hat. Beispiel: \"Sommerkampagne-2024\".",
			automationCampaign: "Automatisierte Kampagne",
			tooltipAutomationCampaign: "Wenn eine Campaign-Automation-ID angegeben ist (z. B. zur Bereitstellung eines kostenlosen PDFs), wird der Abonnent nach Bestätigung des Double-Opt-ins automatisch dieser Kampagne hinzugefügt. Die Kampagne muss zuvor in ELAINE (Newsletter-Tool) angelegt werden.",
			tooltipNewsletterWidgetName: "Der Newsletter-Widget-Titel ist nur für internen Gebrauch bestimmt.",
			template: "Design",
			headline: "Überschrift",
			text: "Text",
			newsletterWidget: "Newsletter-Widget",
			selectNewsletterWidget: "Newsletter-Widget auswählen",
			tagLine: "Vorzeile",
			imageSelectorDescription: "Bild auswählen oder hochladen",
			recipientGroupsCached: "Empfängergruppen werden aus dem Cache geladen. Elaine ist nicht erreichbar.",
			recipientGroupsLoadError: "Empfängergruppen konnten nicht geladen werden.",
			recipientGroupsBrandNotConfigured: "Für diese Marke sind keine Empfängergruppen konfiguriert.",
			recipientGroupsElaineError: "Empfängergruppen konnten nicht geladen werden.",
			recipientGroupsElaineDown: "Empfängergruppen konnten nicht geladen werden. Elaine ist nicht erreichbar.",
			noRecipientGroups: "Keine Empfängergruppen gefunden"
		},
		newsletterEdit: {
			label: "Bezeichnung",
			counter: "Zähler",
			editNewsletter: "Newsletter bearbeiten",
			messageSaved: "Neues Newsletter gespeichert"
		}
	}
}, o = [{
	path: "/newsletter",
	children: [
		{
			path: "",
			name: "newsletter_list",
			component: () => import("./newsletter-list.view-Dqr0PlyS.js"),
			meta: { requiredRight: "newsletters:navigate" }
		},
		{
			path: "new",
			name: "newsletter_new",
			component: () => import("./newsletter-edit.view-DBarwuMT.js"),
			props: () => ({
				title: i().t("newsletter.newNewsletter"),
				backRoute: "/newsletter"
			}),
			meta: { requiredRight: ["newsletters:navigate"] }
		},
		{
			path: ":id",
			name: "newsletter_detail",
			component: () => import("./newsletter-edit.view-DBarwuMT.js"),
			props: (e) => ({
				title: i().t("newsletterEdit.editNewsletter"),
				id: e.params.id,
				backRoute: "/newsletter"
			}),
			meta: { requiredRight: ["newsletters:navigate"] }
		}
	]
}], s = r(() => import("./newsletter-content-block-BN1JYU2d.js")), c = {
	messages: a,
	routes: o,
	contentBlocks: [{
		type: "NEWSLETTER",
		label: "newsletter.newsletterWidget",
		icon: "mail",
		component: s,
		defaultValue: { type: "NEWSLETTER" }
	}]
};
//#endregion
export { s as NewsletterContentBlock, n as NewsletterListSelector, t as getEmptyNewsletter, e as getNewsletter, c as newsletterModule };

//# sourceMappingURL=index.es.js.map